<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10" v-if="type !== 'add'">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_isSchedule') || '行程状态'">
            <el-radio-group v-model="formData.isSchedule">
              <el-radio label="N" disabled>{{
                $l('btn_new') || '新增'
              }}</el-radio>
              <el-radio label="Y">{{ $l('btn_normal') || '正常' }}</el-radio>
              <el-radio label="C">{{ $l('btn_cancel') || '取消' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.label_beginDate') || '开始日期'"
            prop="scheduleStartDate"
          >
            <el-date-picker
              v-model="formData.scheduleStartDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              :picker-options="scheduleStartDatePicker"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.label_endDate') || '结束日期'"
            prop="scheduleEndDate"
          >
            <el-date-picker
              v-model="formData.scheduleEndDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              :picker-options="scheduleEndDatePicker"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_departureCityName') || '出差起始地'"
            prop="departureCityCode"
          >
            <dict-select
              v-model="formData.departureCityCode"
              url="/master/common/dict/biz"
              :body="departureCityParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.departureCityName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_destinationCityName') || '出差目的地'"
            prop="destinationCityCode"
          >
            <dict-select
              v-model="formData.destinationCityCode"
              url="/master/common/dict/biz"
              :body="departureCityParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.destinationCityName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_trip_type') || '出差目的'"
            prop="tripType"
          >
            <dict-select
              v-model="formData.tripType"
              url="/master/common/dict/biz"
              :body="tripTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
              style="width:100%"
              :selectedLabel.sync="formData.v_tripType"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_custCode') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
              style="width:100%"
              @change="changeCustAndOrder"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item
            :label="$l('form_label_depCode') || '分摊部门'"
            prop="depCode"
          >
            <!-- TODO -->
            <CustomerCostSector
              ref="costSector"
              :depCode.sync="formData.depCode"
              :displayDepCode.sync="formData.displayDepCode"
              :orgDepFullName.sync="formData.orgDepFullName"
              :custCode="formData.custCode"
              :userCode="salesPersonCode"
              :autoSelect="!tripReimbursementItemCode"
              size="mini"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item :label="$l('table_label_scm') || '供应商'">
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item
            :label="$l('INDEX.form_customerOrderNo') || '客户订单号'"
          >
            <el-select
              v-model="formData.custAndOrderList"
              filterable
              clearable
              multiple
              size="mini"
              style="width:100%"
              :disabled="orderDisabled"
            >
              <el-option
                v-for="item in optionData"
                :key="item.value"
                :label="item.label"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item :label="$l('form_label_brand') || '品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('form_label_please_select_brand') || '请选择品牌'
              "
              style="width: 100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item
            :label="$l('form_label_tripPurpose') || '预计解决什么问题'"
            prop="tripPurpose"
          >
            <el-input
              v-model="formData.tripPurpose"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="3"
              maxlength="500"
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_ticketFee') || '机票车票费'">
            <el-input-number
              v-model="formData.ticketFee"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="2"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              :disabled="disableAmount"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_trafficFee') || '交通费'">
            <el-input-number
              v-model="formData.trafficFee"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="2"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              :disabled="disableAmount"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_hotelFee') || '住宿费'">
            <el-input-number
              v-model="formData.hotelFee"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="2"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              :disabled="disableAmount"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_travellingAllowance') || '住勤补贴'"
          >
            <el-input-number
              v-model="formData.travellingAllowance"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="2"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              :disabled="disableAmount"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_otherFee') || '其他'">
            <el-input-number
              v-model="formData.otherFee"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="2"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              :disabled="disableAmount"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_billCount') || '单据张数'">
            <el-input-number
              v-model="formData.billCount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :max="1000000000"
              :precision="0"
              :step="1"
              size="mini"
              style="width:100%"
              controls-position="right"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_subAmount') || '合计金额'">
            <el-input
              v-model="v_subAmount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              readonly
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item :label="$l('form_label_expenseRemark') || '费用说明'">
            <el-input
              v-model="formData.expenseRemark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
import { add } from '@/libs/util.number.js'
import CustomerCostSector from '@/views/digital/components/customer-cost-sector'
export default {
  mixins: [EditLoading],
  components: { CustomerCostSector },
  props: {
    tripReimbursementCode: { type: String, default: '' },
    tripReimbursementItemCode: { type: String, default: '' },
    salesPersonCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    type: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        isSchedule: 'N',
        ticketFee: 0,
        trafficFee: 0,
        hotelFee: 0,
        travellingAllowance: 0,
        otherFee: 0,
        billCount: 0,
      },
      rules: {
        tripType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        scheduleStartDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        scheduleEndDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
        departureCityCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        destinationCityCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        tripReasons: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        tripPurpose: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },

      departureCityParams: { dictType: 'tripCity' },
      tripTypeParams: { dictType: 'purposeOfTrip' },
      scheduleStartDatePicker: this.scheduleEndDate(),
      scheduleEndDatePicker: this.scheduleStartDate(),

      optionData: [],
      orderDisabled: true,
    }
  },
  computed: {
    v_subAmount() {
      return add(
        this.formData.ticketFee || 0,
        add(
          this.formData.trafficFee || 0,
          add(
            this.formData.hotelFee || 0,
            add(
              this.formData.travellingAllowance || 0,
              this.formData.otherFee || 0
            )
          )
        )
      )
    },
    disableAmount() {
      return this.formData.isSchedule === 'C'
    },
  },
  watch: {
    'formData.isSchedule'(val) {
      if (val === 'C') {
        this.formData.ticketFee = 0
        this.formData.trafficFee = 0
        this.formData.hotelFee = 0
        this.formData.travellingAllowance = 0
        this.formData.otherFee = 0
      } else {
        this.rules.depCode[0].required = true
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.tripReimbursementCode || !this.tripReimbursementItemCode) return
      this.$api
        .userTripReimbursementItemDetailApi({
          tripReimbursementItemCode: this.tripReimbursementItemCode,
        })
        .then((res) => {
          this.formData = res.body
          if (this.formData.custCode) {
            this.orderDisabled = false
            this.loadData(this.formData.custCode)
          }

          setTimeout(() => this.$refs.form.clearValidate(), 0)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.formData.subAmount = this.v_subAmount
      this.loadingOpen()

      const custAndOrderList = this.formData.custAndOrderList
      if (custAndOrderList && custAndOrderList.length > 0) {
        let custList = ''
        let orderList = ''
        custAndOrderList.forEach((item) => {
          custList += item.label + ','
          orderList += item.value + ','
        })
        custList = custList.substring(0, custList.length - 1)
        orderList = orderList.substring(0, orderList.length - 1)
        this.formData.custOrderNoList = custList
        this.formData.orderCodeList = orderList
      } else {
        this.formData.custOrderNoList = ''
        this.formData.orderCodeList = ''
      }

      this.$api
        .userTripReimbursementItemSaveApi({
          tripReimbursementCode: this.tripReimbursementCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
          this.$emit('getItemData')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    // 日期限制
    scheduleEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.scheduleEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.formData.scheduleEndDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
    scheduleStartDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.scheduleStartDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.formData.scheduleStartDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    async loadData(custCode) {
      const res = await request({
        url: '/factory/orderInfo/select',
        data: { custCode },
        method: 'POST',
      })
      if (res.body.data) {
        this.optionData = res.body.data.map((m) => {
          return { value: m.orderCode, label: m.custOrderNo }
        })
      }
    },
    changeCustAndOrder() {
      const custCode = this.formData.custCode
      if (custCode) {
        this.loadData(custCode)
        this.orderDisabled = false
      } else {
        this.orderDisabled = true
      }
      this.formData.custAndOrderList = []

      // 清空分摊部门
      this.$refs.costSector.clear()
    },
  },
}
</script>
